import { createAuthClient } from "better-auth/react";
import {
  emailOTPClient,
  organizationClient,
  phoneNumberClient,
} from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:9000";

export const authClient = createAuthClient({
  baseURL: `${apiUrl}/api/auth`,
  plugins: [
    organizationClient(),
    emailOTPClient(),
    phoneNumberClient(),
    passkeyClient(),
  ],
});

export const { useSession, signOut } = authClient;
